import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InventoryLookup'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InventoryLookupStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryLookupStore",
			variables: false,
		})
	}
}

export async function load_InventoryLookup(params) {
  await initClient()

	const store = new InventoryLookupStore()

	await store.fetch(params)

	return {
		InventoryLookup: store,
	}
}
